import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Index from './pages/Index';
import Post from './pages/Post';
import CadavreExquis from './pages/CadavreExquis';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/app" element={<CadavreExquis />} />
        <Route path="/post" element={<Post />} />
      </Routes>
    </Router>
  );
}

export default App;